import type { IconData } from '@stacksjs/iconify-core'

export const chevronsSquareDownLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4 10h3a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1V9a1 1 0 1 1 2 0zm3-3h3a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronsSquareDownLeft
